import React from 'react';

interface StatTileProps {
  label: string;
  value: string | number;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  icon?: React.ReactNode;
  className?: string;
}

export const StatTile: React.FC<StatTileProps> = ({
  label,
  value,
  trend,
  icon,
  className = ''
}) => {
  return (
    <div className={`bg-[var(--v-surface-1)] border border-[var(--v-border-light)] rounded-[var(--v-radius-xl)] p-5 shadow-[var(--v-shadow-xs)] ${className}`}>
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-sm font-medium text-[var(--v-text-secondary)]">{label}</h3>
        {icon && <div className="text-[var(--v-teal-700)] bg-[var(--v-teal-50)] p-2 rounded-lg">{icon}</div>}
      </div>
      
      <div className="flex items-baseline gap-3 mt-1">
        <span className="text-3xl font-extrabold text-[var(--v-text-primary)] tracking-tight">{value}</span>
        
        {trend && (
          <span className={`flex items-center text-sm font-medium ${trend.isPositive ? 'text-[var(--v-success)]' : 'text-[var(--v-danger)]'}`}>
            {trend.isPositive ? '↑' : '↓'} {trend.value}
          </span>
        )}
      </div>
    </div>
  );
};
